/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Custom quick-add behavior: auto-select the color option and skip
   * that step, so the customer goes straight to "select size".
   *
   * Forward flow: observes the quick-add form for when the color/swatch
   * step becomes active, then auto-checks a value and dispatches a native
   * 'change' event, so the theme's own logic advances to the next step
   * exactly as if the customer had clicked it.
   *
   * Back flow: when the customer clicks "back" from the size step, the
   * color step is momentarily hidden from the theme's own logic (by
   * removing the attribute it uses to detect it), so the theme's built-in
   * back-button behavior naturally returns straight to the initial
   * "Add to cart" button instead of showing the color step.
   */

  function autoSelectColorStep(optionHolder) {
    if (!optionHolder || optionHolder.getAttribute('data-select-swatch-option') !== 'true') {
      return;
    }

    var checkedInput = optionHolder.querySelector('input:checked');
    var fallbackInput = optionHolder.querySelector('input:not([disabled])');
    var targetInput = checkedInput || fallbackInput;

    if (targetInput) {
      targetInput.checked = true;
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function watchQuickAddForms() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') {
          return;
        }

        var target = mutation.target;

        if (
          target.matches &&
          target.matches('[data-select-option]') &&
          target.classList.contains('is-active')
        ) {
          autoSelectColorStep(target);
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  function watchBackButtonClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var backButton = event.target.closest('[data-back-button]');
        if (!backButton) {
          return;
        }

        var currentHolder = backButton.closest('[data-select-option]');
        if (!currentHolder) {
          return;
        }

        var previousHolder = currentHolder.previousElementSibling;

        if (previousHolder && previousHolder.getAttribute('data-select-swatch-option') === 'true') {
          // Hide the color step from the theme's own "go back" logic just
          // for this click, so it jumps straight to the "Add to cart" button.
          previousHolder.removeAttribute('data-select-option');

          setTimeout(function () {
            previousHolder.setAttribute('data-select-option', '');
          }, 0);
        }
      },
      true // capture phase: runs before the theme's own click handler
    );
  }

  /**
   * Prevent the theme's native cart drawer/page-navigation fallback while
   * MonsterCart is present on the page. MonsterCart is the cart drawer in
   * use on this store, so the theme's own drawer should never open — and
   * critically, the theme should never think the drawer "failed" and
   * fall back to a full navigation to /cart.
   *
   * Instead of leaving openCartDropdown as a no-op (which left the
   * theme's internal state inconsistent and triggered a fallback
   * navigation to the cart page), we make it look like the native
   * drawer opened successfully, without actually showing it.
   */
  function disableNativeDrawerIfMonsterCartPresent() {
    if (!window.cart || typeof window.cart.openCartDropdown !== 'function') {
      return;
    }

    var monsterCartPresent = document.getElementById('monster-cart-wrapper');

    if (!monsterCartPresent) {
      return;
    }

    window.cart.openCartDropdown = function () {
      window.cart.cartDropdownIsOpen = true;
    };
  }

  /**
   * MonsterCart (Reelfy) integration fix.
   *
   * MonsterCart listens for a real 'submit' event at the window level
   * (capture phase), which only happens on the product page (real form
   * submit). Quick-add never submits a form — it uses fetch() directly —
   * so MonsterCart never sees it. This dispatches a synthetic 'submit'
   * event on the quick-add form right after the cart:add-to-cart flow,
   * so capture-phase listeners on window see the same signal.
   *
   * Safety net: always prevent the browser's real form submission (full
   * page navigation to /cart), regardless of whether any other listener
   * (theme, MonsterCart) calls preventDefault() itself.
   */
  function bridgeQuickAddCartEvent() {
    document.addEventListener(
      'cart:add-to-cart',
      function (event) {
        var target = event.target;
        var holder = event.detail && event.detail.element;
        var form =
          (holder && holder.querySelector && holder.querySelector('form')) ||
          (target && target.closest && target.closest('form'));

        if (!form) {
          return;
        }

        var preventNativeSubmit = function (submitEvent) {
          submitEvent.preventDefault();
        };

        form.addEventListener('submit', preventNativeSubmit, { capture: true });

        form.dispatchEvent(
          new Event('submit', { bubbles: true, cancelable: true })
        );

        form.removeEventListener('submit', preventNativeSubmit, { capture: true });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchQuickAddForms();
      watchBackButtonClicks();
      disableNativeDrawerIfMonsterCartPresent();
      bridgeQuickAddCartEvent();
    });
  } else {
    watchQuickAddForms();
    watchBackButtonClicks();
    disableNativeDrawerIfMonsterCartPresent();
    bridgeQuickAddCartEvent();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();